<template>
  <div>
    <div class="case-tabs">
      <div :class="['case-tab', 'case-tab-predmet', active_tab == 'kalendar' ? 'active':'']" @click="queryParamSwitch('kalendar');">{{$t('components.calendar.calendar_tab.t1')}}</div>
      <div :class="['case-tab', 'case-tab-sudionici', active_tab == 'paznja' ? 'active':'']" @click="queryParamSwitch('paznja');">{{$t('components.calendar.calendar_tab.t2')}}</div>
      <div :class="['case-tab', 'case-tab-spisi', active_tab == 'nadolazeci' ? 'active':'']" @click="queryParamSwitch('nadolazeci');">{{$t('components.calendar.calendar_tab.t3')}}</div>
      <div :class="['case-tab', 'case-tab-pošta', active_tab == 'rjeseni' ? 'active':'']" @click="queryParamSwitch('rjeseni');">{{$t('components.calendar.calendar_tab.t4')}}</div>
      <div :class="['case-tab', 'case-tab-pošta', active_tab == 'rocista' ? 'active':'']" @click="queryParamSwitch('rocista');">{{$t('components.calendar.calendar_tab.t5')}}</div>
      <div :class="['case-tab', 'case-tab-pošta', active_tab == 'kalovi' ? 'active':'']" @click="queryParamSwitch('kalovi');">{{$t('components.calendar.calendar_tab.t6')}}</div>

      <!-- <div class="case-tab case-tab-financije">Putni Nalog</div> -->
    </div>
    <!-- <CaseTab current_tab="Kalendar"/> -->
    <div class="upload-dokumenta-button kalendar-novi-button" style="top:7rem" @click="goToForm">
      {{$t('components.calendar.btn_1')}}
      <div class="upload-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 12 12"
        >
          <g>
            <g>
              <path
                fill="#fff"
                d="M11.465 4.767a.73.73 0 0 0-.537-.22h-3.28V1.265a.73.73 0 0 0-.221-.537.73.73 0 0 0-.536-.22H5.377a.73.73 0 0 0-.537.22.73.73 0 0 0-.22.537v3.28H1.339a.73.73 0 0 0-.536.221.729.729 0 0 0-.221.536v1.515c0 .21.073.389.22.536a.73.73 0 0 0 .537.22h3.28v3.281c0 .21.074.39.221.537a.73.73 0 0 0 .537.22H6.89a.73.73 0 0 0 .536-.22.73.73 0 0 0 .22-.537v-3.28h3.281a.73.73 0 0 0 .537-.221.73.73 0 0 0 .22-.536V5.303a.73.73 0 0 0-.22-.536z"
              />
            </g>
          </g>
        </svg>
      </div>
    </div>
    <CalendarComponent v-if="active_tab == 'kalendar'" />
    <EventListsComponent v-else :tab_name="active_tab" :key="updateKey"/>
    <!-- <calendar-create-edit
      :accessToken="accessToken"
      :spisList="rootSpisi"
      :caseId="predmet_info.broj_predmeta"
    ></calendar-create-edit> -->
  </div>
</template>

<script>
import auth from "@/services/auth";
import CalendarComponent from "@/components/calendarComponents/CalendarComponent.vue";
import CaseTab from "@/components/caseComponents/CaseTab.vue";
import EventListsComponent from "@/components/calendarComponents/EventListsComponent.vue";
export default {
  components: { CaseTab, CalendarComponent, EventListsComponent},
  data: function () {
    return {
      //CURRENT CASE DATA BEGIN
      accessToken: "",
      active_tab:'kalendar',
      updateKey:0
    };
  },
  methods: {
    goToForm(){
      console.log(this.$router);
      this.$router.push("/kalendar/novi-osobni-dogadaj");
    },
    queryParamSwitch(cal_type)
    {
      this.$router.push({ path: 'kalendar', query: { active_tab: cal_type }})
    }
  },
  async created() {
    this.accessToken = this.$store.state.aToken 
    if(this.$route.query.active_tab != undefined)
    {
      this.active_tab = this.$route.query.active_tab;
    }
  },
};
</script>

<style>
</style>